export default "__VITE_ASSET__CFE2oIvU__"